<template>
  <BasePopup v-model="isTermsPopupOpen" :customClass="props.tncInfo.customClass">
    <div class="popup-header">
      <h3 class="title">{{ props.tncInfo.hcTncKndCdNm}}</h3>
      <button type="button" class="btn-cancel" @click="handleClose"></button>
    </div>
      <slot></slot>
    <div class="popup-footer jc-c">
      <div class="button-box">
        <button type="button" @click="handleClose" class="btn lg">확인</button>
      </div>
    </div>
  </BasePopup>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import BasePopup from '@/components/com/HconComBasePopup.vue'
import type { TncInfoDto } from '~/types/common/backend-dto-types';

// 팝업
const isTermsPopupOpen = ref(false)

// 팝업 열림
const handleOpen = () => {
  emit('open');
  isTermsPopupOpen.value = true
}

onMounted(() => {
  handleOpen();
})

// 부모컴포넌트에 넘길 값
const emit = defineEmits(['open','close']);

// 확인 버튼 click 이벤트 > 팝업 닫힘
const handleClose = () => {
  emit('close');
  isTermsPopupOpen.value = false;
}

// 부모컴포넌트로부터 받은 값
const props = defineProps<{
  tncInfo: TncInfoDto
}>()

</script>